import script from "./FragChannel.vue?vue&type=script&lang=ts&setup=true"
export * from "./FragChannel.vue?vue&type=script&lang=ts&setup=true"

import "./FragChannel.vue?vue&type=style&index=0&id=093b66e9&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-093b66e9"]])

export default __exports__